module.exports = __webpack_public_path__ + "static/addresses-7b1056d82db383142b1288e84cab08cc.png";